<template>
  <div class="im-image-message" @click="onPreviewImage" @longpress="onlongpress">
    <img class="image" :src="image" />
    <div v-if="showProgress && percent" class="progress-wrap">
      <progress
        :percent="percent"
        class="progress"
        :show-info="true"
        active
        stroke-width="3"
        @activeend="onEnd"
      ></progress>
    </div>
  </div>
</template>

<script>
import { getElementBoundingClientReact } from '@/timpackage/utils/timInit'
import { ImagePreview } from 'vant'
export default {
  name: 'imImageMessage',
  props: {
    message: {
      type: Object,
      default() {
        return {
          palyload: {
            imageInfoArray: []
          }
        }
      }
    },
    messageList: {
      // 获取消息列表，预览列表图片
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      showProgress: this.message.showProgress
    }
  },
  computed: {
    image() {
      const {
        payload: {
          // eslint-disable-next-line
          imageInfoArray: [{}, {}, { imageUrl }]
        }
      } = this.message
      return imageUrl
    },
    percent() {
      return this.message.progress * 100
    }
  },
  methods: {
    async onlongpress() {
      const info = await getElementBoundingClientReact('.im-image-message', this)
      this.$emit('menu', {
        info,
        message: this.message
      })
    },
    onPreviewImage() {
      let current = 0
      const images = this.messageList.reduce((res, { payload: { imageInfoArray } }, index) => {
        if (
          imageInfoArray &&
          imageInfoArray[2] &&
          (this.image === imageInfoArray[2].imageUrl || this.image === imageInfoArray[2].url)
        ) {
          current = res.length
        }
        // 图片才有改字段 imageInfoArray 0：原图 1: 198p压缩图 2: 720p压缩图
        imageInfoArray && imageInfoArray.length && res.push(imageInfoArray[0].imageUrl)
        return res
      }, [])
      ImagePreview({
        images,
        startPosition: current,
        closeable: true
      })
      this.$emit('previewImage', this.image)
    },
    onEnd() {
      this.showProgress = false
      // eslint-disable-next-line vue/no-mutating-props
      this.message.showProgress = false
    }
  }
}
</script>

<style lang="scss" scoped>
.im-image-message {
  // overflow: hidden;
  position: relative;
  width: 5.802667rem;
  height: 5.802667rem;
  border-radius: 0.170667rem;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  .image {
    display: block;
    width: 5.802667rem;
    height: 5.802667rem;
    border-radius: 0.170667rem;
  }

  .progress-wrap {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 0.853333rem;
    background: rgba(225, 225, 225, 0.5);
    z-index: 10;

    .progress {
      margin: 0 auto;
      height: 0.853333rem;
    }
  }
}
</style>
